import AnalyticsDashboard from "@/components/CRM/Analytics/AnalyticsDashboard";
import Loader from "@/components/Loader/Loader";
import { Suspense } from "react";
import { Route } from "react-router-dom";

const AnalyticsRoutes = [
    <Route
        path="analytics"
        element={
            <Suspense fallback={<Loader />}>
                <AnalyticsDashboard />
            </Suspense>
        }
        key="analytics"
    />,
];

export default AnalyticsRoutes;
